<p-treeSelect
  [(ngModel)]="selectedValue"
  [ngModelOptions]="{ standalone: true }"
  [inputId]="inputId"
  [options]="treeNodes()"
  selectionMode="single"
  [filter]="true"
  filterBy="label"
  [showClear]="true"
  [placeholder]="placeholder"
  [disabled]="readonly"
  appendTo="body"
  styleClass="w-full"
  [ngClass]="{ 'ng-invalid ng-dirty': control.invalid && control.touched }"
  (onNodeSelect)="onNodeSelect($event)"
  (onNodeUnselect)="onClear()"
  (onClear)="onClear()"
>
  <ng-template pTemplate="value">
    @if (display(); as text) {
      <span>{{ text }}</span>
    } @else {
      <span class="text-surface-400">{{ placeholder }}</span>
    }
  </ng-template>
</p-treeSelect>
